module.exports = {"HAS_REFUND_INVOICE_NUMBER":false}


//////////////////
// WEBPACK FOOTER
// ./src/plugins/tfs/platformConfigs/theme/order.json
// module id = 1368
// module chunks = 1